import { LevelDesignerComponent } from '../level-designer/level-designer.component';
import { LevelDesignerElementBase } from '../elements/element-base';

export interface MouseEventResult {
    cursor: string;
    stopPropagation: boolean;
    redraw: boolean;
}

export abstract class ManagerBase {
    protected ctx: CanvasRenderingContext2D;

    constructor(
        protected levelDesigner: LevelDesignerComponent,
        protected canvas: HTMLCanvasElement,
    ) {
        this.ctx = canvas.getContext('2d')!;
    }

    protected getMousePosition(event: MouseEvent): { x: number, y: number } {
        return {
            x: (event.offsetX - this.levelDesigner.getOffsetX()) / this.levelDesigner.getScale(),
            y: (event.offsetY - this.levelDesigner.getOffsetY()) / this.levelDesigner.getScale()
        };
    }

    public abstract OnDraw(): void;

    // New optional handler methods
    public handleMouseDown?(event: MouseEvent): MouseEventResult | undefined;
    public handleMouseMove?(event: MouseEvent): MouseEventResult | undefined;
    public handleMouseUp?(event: MouseEvent): MouseEventResult | undefined;
    public handleWheel?(event: WheelEvent): boolean;
    public handleKeyDown?(event: KeyboardEvent): void;
    public handleKeyUp?(event: KeyboardEvent): void;
    public handleDoubleClick?(event: MouseEvent): MouseEventResult | undefined;
}
